/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerSearchQueryResponse,
  TelegramGeoControllerSearchQueryParams,
} from '../../types/TelegramGeoControllerSearch.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoSearch } from '../../methods/telegramGeoSearch.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoSearchQueryKey = (params: TelegramGeoControllerSearchQueryParams) =>
  [{ url: '/api/telegram/geo/search' }, ...(params ? [params] : [])] as const;

export type TelegramGeoSearchQueryKey = ReturnType<typeof telegramGeoSearchQueryKey>;

export function telegramGeoSearchQueryOptions(
  params: TelegramGeoControllerSearchQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoSearchQueryKey(params);
  return queryOptions<
    TelegramGeoControllerSearchQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerSearchQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoSearch(params, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/search}
 */
export function useTelegramGeoSearch<
  TData = TelegramGeoControllerSearchQueryResponse,
  TQueryData = TelegramGeoControllerSearchQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoSearchQueryKey,
>(
  params: TelegramGeoControllerSearchQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerSearchQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoSearchQueryKey(params);

  const query = useQuery(
    {
      ...telegramGeoSearchQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
